import React, { useEffect, useMemo } from 'react';
import { useGetDeliveryCityByZip } from '../../../../../shared/delivery/hooks/delivery.hooks';
import {
  getDeliveryCitySchedule,
  getDeliveryDayFromDeliveryDate,
} from '../../../../../shared/delivery/utils/delivery.utils';
import moment from 'moment/moment';
import DeliveryAdressFormControl from '../../../../../components/Admin/Delivery/DeliveryAdressFormControl';
import DeliveryDateFormControl from '../../../../../components/Admin/Delivery/DeliveryDateFormControl';
import { addressToDeliveryAddress } from '../../../../../shared/delivery/utils/home/homeDelivery.utils';

export default function HomeDeliveryController({
  isCreateOrder,
  lastOrder,
  addresses,
  selectedDeliveryDay,
  selectedDeliveryAddress,
  setSelectedDeliveryDay,
  setSelectedDeliveryAddress,
  setSelectedBillingAddress,
}) {
  const defaultAddress = useMemo(() => {
    const selectedId = selectedDeliveryAddress?._id ?? selectedDeliveryAddress?.id;
    if (selectedId) return addresses.find((address) => (address._id ?? address.id) === selectedId);
    return addresses.find((address) => address.isMain) ?? addresses[0];
  }, [addresses, selectedDeliveryAddress]);

  const { deliveryCity } = useGetDeliveryCityByZip({ zipCode: defaultAddress?.zipCode });
  const deliveryDays = useMemo(() => {
    if (!deliveryCity) return null;

    return getDeliveryCitySchedule({
      schedules: deliveryCity.infos,
      interval: { from: moment(), to: moment().add(14, 'days') },
    });
  }, [deliveryCity]);

  const handleChangeAddress = (value) => {
    const selectedAdress = addresses.find((address) => (address._id ?? address.id) === value);
    setSelectedDeliveryAddress(selectedAdress ? addressToDeliveryAddress(selectedAdress) : null);
    setSelectedBillingAddress(selectedAdress ? addressToDeliveryAddress(selectedAdress) : null);
  };

  useEffect(() => {
    if (!selectedDeliveryAddress && defaultAddress) {
      const deliveryAddress = addressToDeliveryAddress(defaultAddress);
      setSelectedDeliveryAddress(deliveryAddress);
      setSelectedBillingAddress(deliveryAddress);
    }
  }, [selectedDeliveryAddress, setSelectedDeliveryAddress, setSelectedBillingAddress, defaultAddress]);

  useEffect(() => {
    if (lastOrder) {
      const { deliveryInfos } = lastOrder;

      if (isCreateOrder) {
        setSelectedDeliveryAddress(deliveryInfos.deliveryAddress);
        setSelectedBillingAddress(deliveryInfos.deliveryBillingAddress);

        if (deliveryDays) return setSelectedDeliveryDay(deliveryDays[0]);
      } else {
        const formattedDeliveryDay = getDeliveryDayFromDeliveryDate({
          deliveryDate: deliveryInfos.deliveryDate,
          deliverySchedule: deliveryInfos.deliverySchedule,
        });
        return setSelectedDeliveryDay(formattedDeliveryDay);
      }
    }
  }, [lastOrder, isCreateOrder, deliveryDays]);

  useEffect(() => {
    if (isCreateOrder && !selectedDeliveryDay && deliveryDays && deliveryDays.length > 0) {
      setSelectedDeliveryDay(deliveryDays[0]);
    }
  }, [isCreateOrder, selectedDeliveryDay, deliveryDays, setSelectedDeliveryDay]);

  return (
    <>
      <DeliveryAdressFormControl
        adresses={addresses}
        deliveryAddressId={defaultAddress?._id ?? defaultAddress?.id ?? ''}
        handleChangeAddress={handleChangeAddress}
      />

      {deliveryDays && selectedDeliveryAddress && (
        <DeliveryDateFormControl
          deliveryDays={deliveryDays}
          selectedDeliveryDay={selectedDeliveryDay}
          setSelectedDeliveryDay={setSelectedDeliveryDay}
        />
      )}
    </>
  );
}
